import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpStatusCode } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs';
import { Router } from '@angular/router';
import { IAppState } from '@core/state/state.service';
import { Store } from '@ngrx/store';
import { AppConfigService } from '@core/services/config/app-config.service';

export const GUID_REGEX_STRING =
  '[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}';

@Injectable({
  providedIn: 'root',
})
export class ProjectAuthorizationInterceptorService implements HttpInterceptor {
  private readonly apiUrl: string;

  constructor(
    private router: Router,
    private _store: Store,
    private _appConfig: AppConfigService
  ) {
    this.apiUrl = _appConfig.config.apiUrl;
  }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error) => {
        const isProjectRelatedEndpointRegex = new RegExp(
          `^${this.escapeRegExp(this.apiUrl)}/projects`
        );
        if (
          isProjectRelatedEndpointRegex.test(req.url) &&
          error instanceof HttpErrorResponse &&
          error.status === HttpStatusCode.Forbidden
        ) {
          const regex = new RegExp(
            `^${this.escapeRegExp(this.apiUrl)}/projects/(${GUID_REGEX_STRING})`
          );
          const projectId = regex.exec(req.url)[1];
          if (projectId !== null) {
            this.router.navigate(['/projects', { projectId }]);
          }
        }
        return throwError(error);
      })
    );
  }

  // Code paths for handling HTTP redirect interception
  // 1) http request to access project user is authorized for
  //    - no redirect
  //    - return observable of original HTTP response (or rethrow error)
  // 2) http request to access to public project user is not authorized for
  //    - redirect to project listing page with join dialog for given project
  //    - throw error for original HTTP request
  // 3) http request to access private project user is not authorized for
  //    - redirect to project listing page with information dialog
  //      explaining they should contact project owner
  //    - throw error for original HTTP request
  // 4) http request to an endpoint not associated with a project
  //    - no redirect
  //    - return observable of original HTTP response (or rethrow error)

  escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
  }
}
